import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Container, Card, CardContent } from "@material-ui/core";
import Results from "../Lists/MachineList";
import Page from "src/components/Page";
import PageHeader from "src/components/PageHeader";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

function Machines(props) {
  const classes = useStyles();
  const { t } = useTranslation(["glossary", "common"]);

  return (
    <Page className={classes.root} title="Machines">
      <Container maxWidth={false}>
        <PageHeader pageTitle={t("machines")} />
        <Card>
          <CardContent className={classes.content}>
            <Results className={classes.results} />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default Machines;
